import { Product_Family_Name_Enum, Product_Sub_Family_Name_Enum } from '@kheops/graphql';
import { productFamilyMap } from '@kheops/utils';

export default class ProductUtils {
  static isAlcoholProduct(sub_family: Product_Sub_Family_Name_Enum): boolean {
    const alcoholFamilies = [Product_Sub_Family_Name_Enum.BeerCider, Product_Sub_Family_Name_Enum.WineChampagneSparkling, Product_Sub_Family_Name_Enum.Spirits];

    return alcoholFamilies.includes(sub_family);
  }
}

export function isNonFoodProduct(subFamily: Product_Sub_Family_Name_Enum): boolean {
  return productFamilyMap[Product_Family_Name_Enum.NonFoodProducts].includes(subFamily);
}
